export enum ContinuityEscrowRoutesEnum {
  Overview = 'overview',
  Agreement = 'agreement',
  Environment = 'environment',
  Settings = 'settings',
  Members = 'members',
  Reports = 'reports',
}

export enum ContinuityEscrowSettingsRoutesEnum {
  Agreement = 'agreement',
  Beneficiary = 'beneficiary',
  Depositor = 'depositor',
  Technical = 'technical',
}
